export class ProdutoIdadeCartao {
  public idadeMaxima!: number;
  public fatorRMC!: number;
  public valorMaximo!: number;
  public prazoMaximo!: number;
}